import { Entity, EntityRecord } from "@/orm/types";
import { Route } from "@/paths";
import { Button, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useAtomValue } from "jotai";
import { useAsyncCallback } from "react-async-hook";
import { BiTrash } from "react-icons/bi";
import { generatePath, useNavigate } from "react-router-dom";

export const DeleteButton = <T extends EntityRecord = EntityRecord>({
  entity,
  confirmationPath,
  getName,
}: {
  entity: Entity<T>;
  confirmationPath?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getName?: (item: any) => string;
}) => {
  const navigate = useNavigate();
  const { data: item } = useAtomValue(entity.getObserveEntityRecordAtom());
  const { loading, execute: remove } = useAsyncCallback(entity.remove);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const name = getName ? getName(item) : (item as any)?.name || "Unlabeled";

  const onConfirm = async () => {
    await remove();
    navigate(generatePath(confirmationPath || Route.DealTracker));
  };

  const openDeleteModal = async () => {
    await modals.openConfirmModal({
      title: `Delete this ${entity.model.labels.singular.toLowerCase()}`,

      children: (
        <Text size="md">
          Are you sure you want to delete the <strong>"{name}"</strong> deal?
          This action is destructive and can't be undone.
        </Text>
      ),
      labels: {
        confirm: `Delete this  ${entity.model.labels.singular.toLowerCase()}`,
        cancel: "Cancel",
      },
      confirmProps: { color: "red" },
      onConfirm: onConfirm,
    });
  };

  return (
    <Button
      loading={loading}
      variant="light"
      color="red"
      leftSection={<BiTrash />}
      fullWidth
      onClick={openDeleteModal}
    >
      Delete
    </Button>
  );
};
